import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import * as fromApp from '../../../store/app.reducers';
import {Chart} from 'angular-highcharts';
import * as fromProfile from '../../store/profile.reducers';
import {Observable, Subscription} from 'rxjs';
import {ActivatedRoute, Params} from '@angular/router';
import {Store} from '@ngrx/store';
import * as ProfileActions from '../../store/profile.actions';
import {ChartService} from '../../chart.service';
import {UserService} from '../../../user/user.service';

@Component({
    selector: 'app-comment-time',
    templateUrl: './comment-time.component.html',
    styleUrls: ['./comment-time.component.scss'],
    standalone: false
})
export class CommentTimeComponent implements OnInit, OnDestroy {

  @Input() id: number;
  profileState: Observable<fromProfile.State>;
  routeSubscription: Subscription;
  profileSubscription: Subscription;
  chartsMediaCommentAnalyze: Chart[];

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private userService: UserService

  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        if (params.id !== undefined) {
          this.id = params.id;
        }
        const code = params.code;
        if (this.id !== undefined) {
          this.store.dispatch(
            new ProfileActions.GetMediaCommentAnalyze({
              id: +this.id,
              type: 1,
              params: {
                code: code
              }
            })
          );
        }
      }
    );
    this.profileSubscription = this.store.select('profile').subscribe(
      (state: fromProfile.State) => {
        if (state.mediaCommentAnalyze !== null && state.chartReload === ProfileActions.SET_MEDIA_COMMENT_ANALYZE) {
          this.chartsMediaCommentAnalyze = [];
          this.chartsMediaCommentAnalyze.push(
            ChartService.getMediaCommentFromPostDateChart(state.mediaCommentAnalyze['hour']),
            ChartService.getMediaCommentFromPostDateChart(state.mediaCommentAnalyze['day'])
          );
        }

      }
    );
  }

  isAdmin(): Observable<boolean> {
    return this.userService.isAdmin();
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
  }

}
